export const amber = {
  1: { value: { base: '{colors.amber.light.1}', _dark: '{colors.amber.dark.1}' } },
  2: { value: { base: '{colors.amber.light.2}', _dark: '{colors.amber.dark.2}' } },
  3: { value: { base: '{colors.amber.light.3}', _dark: '{colors.amber.dark.3}' } },
  4: { value: { base: '{colors.amber.light.4}', _dark: '{colors.amber.dark.4}' } },
  5: { value: { base: '{colors.amber.light.5}', _dark: '{colors.amber.dark.5}' } },
  6: { value: { base: '{colors.amber.light.6}', _dark: '{colors.amber.dark.6}' } },
  7: { value: { base: '{colors.amber.light.7}', _dark: '{colors.amber.dark.7}' } },
  8: { value: { base: '{colors.amber.light.8}', _dark: '{colors.amber.dark.8}' } },
  9: { value: { base: '{colors.amber.light.9}', _dark: '{colors.amber.dark.9}' } },
  10: { value: { base: '{colors.amber.light.10}', _dark: '{colors.amber.dark.10}' } },
  11: { value: { base: '{colors.amber.light.11}', _dark: '{colors.amber.dark.11}' } },
  12: { value: { base: '{colors.amber.light.12}', _dark: '{colors.amber.dark.12}' } },
  a1: { value: { base: '{colors.amber.light.a1}', _dark: '{colors.amber.dark.a1}' } },
  a2: { value: { base: '{colors.amber.light.a2}', _dark: '{colors.amber.dark.a2}' } },
  a3: { value: { base: '{colors.amber.light.a3}', _dark: '{colors.amber.dark.a3}' } },
  a4: { value: { base: '{colors.amber.light.a4}', _dark: '{colors.amber.dark.a4}' } },
  a5: { value: { base: '{colors.amber.light.a5}', _dark: '{colors.amber.dark.a5}' } },
  a6: { value: { base: '{colors.amber.light.a6}', _dark: '{colors.amber.dark.a6}' } },
  a7: { value: { base: '{colors.amber.light.a7}', _dark: '{colors.amber.dark.a7}' } },
  a8: { value: { base: '{colors.amber.light.a8}', _dark: '{colors.amber.dark.a8}' } },
  a9: { value: { base: '{colors.amber.light.a9}', _dark: '{colors.amber.dark.a9}' } },
  a10: { value: { base: '{colors.amber.light.a10}', _dark: '{colors.amber.dark.a10}' } },
  a11: { value: { base: '{colors.amber.light.a11}', _dark: '{colors.amber.dark.a11}' } },
  a12: { value: { base: '{colors.amber.light.a12}', _dark: '{colors.amber.dark.a12}' } },
}
